import { render, staticRenderFns } from "./ProjectValuationScoreFinancialViabilityTable.vue?vue&type=template&id=2fadddba&scoped=true&"
import script from "./ProjectValuationScoreFinancialViabilityTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScoreFinancialViabilityTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationScoreFinancialViabilityTable.vue?vue&type=style&index=0&id=2fadddba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadddba",
  null
  
)

export default component.exports